import { combineReducers } from "redux";
import detailReducer from "./detail.reducer";
import tokenReducer from "./Token.reducer";

const reducer = combineReducers({
  projectDetail: detailReducer,
  token: tokenReducer,
});

export default reducer;
